// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalDataError_container__1MCxM"};